import React, { useState, useRef, useEffect } from 'react';

const FipDropdown = ({ fipList, selectedFip, onSelectFip,customDetails }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelectFip = (fip) => {
    onSelectFip(fip);
    setIsOpen(false);
  };

  // Get last 4 digits of masked account number
  const getLastFourDigits = (maskedAccNumber) => {
    if (!maskedAccNumber) return '';
    return maskedAccNumber.slice(-4);
  };

  // Render individual FIP option
  const renderFipOption = (fip, isSelected = false) => (
    <div
      key={`${fip.accountDetails.fipId}-${fip.accountDetails.accType}-${fip.accountDetails.maskedAccNumber}`}
      className={`d-flex align-items-center p-2 ${!isSelected ? 'fip-option' : ''}`}
      style={{
        cursor: !isSelected ? 'pointer' : 'default',
        borderBottom: !isSelected ? '1px solid #f0f0f0' : 'none',
        backgroundColor: isSelected ? 'transparent' : 'white',
        minHeight: '40px'
      }}
      onClick={!isSelected ? () => handleSelectFip(fip) : undefined}
    >
      {/* FIP Logo */}
      <div className="flex-shrink-0" style={{ width: '24px', height: '24px', marginLeft:'5px' ,marginBottom:'2.5px', marginRight: '8px'}}>
        {fip.fipLogoUri ? (
          <img
            src={fip.fipLogoUri}
            alt={`${fip.fipName} logo`}
            className="w-100 h-100 rounded"
            style={{
              objectFit: 'contain'
            }}
            onError={(e) => {
              // Fallback if image fails to load
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        
        {/* Fallback logo container */}
        <div
          className={`w-100 h-100 bg-light border rounded d-${fip.fipLogoUri ? 'none' : 'flex'} align-items-center justify-content-center`}
          style={{
            fontSize: '10px',
            fontWeight: '600',
            color: customDetails?.primaryBtnColor
          }}
        >
          {fip.fipName?.charAt(0)?.toUpperCase() || 'FIP'}
        </div>
      </div>

      {/* FIP Details - All in one line */}
      <div className="flex-grow-1">
        <div style={{ fontSize: '12px',color : customDetails?.primaryBtnColor, textAlign: 'left'}}>
          <span className="fw-600" >{fip.fipName || 'Unknown Financial Institution'} •</span>
          <span className="ms-2">{getLastFourDigits(fip.accountDetails.maskedAccNumber)}</span>
        </div>
      </div>

      {isSelected && (
        <div className="ms-2">
          {/* CSS-based chevron */}
          <div
            style={{
              width: '12px',
              height: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease',
            }}
          >
            <div
              style={{
                width: '4px',
                height: '4px',
                borderRight: `1px solid ${customDetails?.primaryBtnColor}`,
                borderBottom: `1px solid ${customDetails?.primaryBtnColor}`,
                transform: 'rotate(45deg)',
                marginTop: '-1px',
              }}
            />
          </div>
        </div>
      )}
    </div>
  );

  if (!fipList || fipList.length === 0) {
    return null;
  }

  // If only one FIP, don't show dropdown
  return (
    <div
      className="mb-3 position-relative fip-dropdown-container"
      ref={dropdownRef}
      style={{
        backgroundColor: "rgba(39, 60, 137, 0.05)",
        borderRadius: '20px',
        border: `1px solid ${customDetails?.primaryBtnColor}`
      }}
    >
      {/* Always render the selected FIP */}
      <div
        onClick={fipList.length > 1 ? toggleDropdown : undefined}
        className="rounded"
        style={{
          cursor: fipList.length > 1 ? 'pointer' : 'default'
        }}
      >
        {renderFipOption(
          fipList.length === 1 ? fipList[0] : selectedFip,
          true
        )}
      </div>
  
      {/* Render dropdown only if more than one FIP */}
      {fipList.length > 1 && isOpen && (
        <div
          className="position-absolute w-100 bg-white border rounded shadow mt-1"
          style={{
            top: '100%',
            left: '0',
            zIndex: 1000,
            maxHeight: '300px',
            overflowY: 'auto',
          }}
        >
          {fipList
            .filter(fip => 
              `${fip.accountDetails.fiType}-${fip.accountDetails.accType}-${fip.accountDetails.maskedAccNumber}` !==
              `${selectedFip.accountDetails.fiType}-${selectedFip.accountDetails.accType}-${selectedFip.accountDetails.maskedAccNumber}`
            )
            .map(fip => renderFipOption(fip, false))
          }
        </div>
      )}
  
      <style jsx>{`
        .fip-option:hover {
          background-color: var(--bs-light) !important;
        }
        .fip-dropdown-container {
          width: 50%;
          border-radius: 3rem;
        }
        @media (max-width: 600px) {
          .fip-dropdown-container {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
  
};

export default FipDropdown;